import { RouteParam } from "../../../routes";
import { ACTION, MODULE } from "../../../utils/enums";
import { urls } from "../../../utils/urls";
import TransformListScreen from "../transform/transform_list_screen";
import TransformCreateScreen from "../transform/transform_create_screen";

const transform_routes: RouteParam[] = [
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.procurement_masters_transform,
    component: TransformListScreen,
    module: MODULE.master_data_panel,
    main_module: MODULE.master_data_panel,
    action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.procurement_masters_transform + "/create",
    component: TransformCreateScreen,
    module: MODULE.master_data_panel,
    main_module: MODULE.master_data_panel,
    action: [ACTION.CREATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.procurement_masters_transform + "/update/:id",
    component: TransformCreateScreen,
    module: MODULE.master_data_panel,
    main_module: MODULE.master_data_panel,
    action: [ACTION.UPDATE],
    operator: "or",
  },
];

export default transform_routes;
